import { LoadState } from "../../constants/enums";
import { ICallCampaign, iCallCampaignState } from "./CallCampaign.type";

export const defaultCallCampaign:ICallCampaign={
    call_campaign_id: 0,
    member_id: "",
    customer_name: "",
    vehicle_no: "",
    phone_res: null,
    phone_off: null,
    mobile_number: "",
    mobile_secondary: null,
    email_id: null,
    registration_year: null,
    membership_start_date: "",
    membership_end_date: "",
    city: null,
    state: null,
    address: null,
    pin: null,
    next_day_call: null,
    next_day_call_time: null,
    dnd_flag: 0,
    interested_plan: null,
    suggested_plan: null,
    interested_flag: null,
    call_disposition: null,
    category: null,
    campaign_name: "",
    scheduled_call_date: null,
    assign_to_id: 0,
    assign_to_name: "",
    lead_id: 0,
    lead_name: "",
    status: "",
    comment: "",
    create_dt: "",
    update_dt: "",
    insert_dt: "",
}

export const defaultCallCampaignState:iCallCampaignState={
    list:{
        data:[],
        totalRecords:0,
        queueCount:0,
        retryCount:0,
        completedCount:0,
        loading:LoadState.NotLoaded,
        error:null
    },
    recordCount:{
        data:[],
        loading:LoadState.NotLoaded
    },
    totalRecords:{
        data:0,
    }
}